<template>
  <zg-module
    v-bind="moduleProps"
    full-width
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <slot />

    <div
      v-if="partners"
      class="logos"
    >
      <zg-logo-card
        v-for="(item, index) in getPartners"
        :key="index"
        :image="item.image"
        :background="cardBackground"
        small
      />
    </div>
  </zg-module>
</template>

<script>
  import module from '../../mixins/module.js'
  import ZgModule from '../sections/ZgModule/ZgModule'
  import ZgLogoCard from '../ZgLogoCard/ZgLogoCard'

  export default {
    name: 'ZgHighlightedPartners',
    components: {
      ZgLogoCard,
      ZgModule
    },
    mixins: [module],
    props: {
      partners: {
        type: Array,
        required: true,
        validator: partners => partners?.length > 0
      }
    },
    computed: {
      getPartners () {
        return this.partners?.slice(0, 6) || []
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .zg-module__title {
    margin: 0 0 rem(24px);

    @include mq(medium) {
      margin: 0;
    }

    h2 {
      margin: 0;

      @include mq(medium) {
        margin: 0 0 rem(16px);
      }
    }
  }

  .logos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: rem(16px);

    @include mq(medium) {
      flex-wrap: nowrap;
      gap: rem(24px);
    }

    & > a,
    & > div {
      flex-basis: calc(100% / 3 - (#{rem(16px)} * 2 / 3));

      @include mq(medium) {
        flex-basis: calc(100% / 6 - (#{rem(24px)} * 2 / 6));
      }
    }
  }
</style>
